/* eslint-disable import/no-anonymous-default-export */
export default {
  auth: {
    accountVerification: "/account-verification/:method",
    consent: "/consent",
    signin: "/",
    hub: "/hub/:id",
    signup: "/sign-up",
    forgotPassword: "/forgot-password",
    resetPassword: "/reset-password",
  },
  clinic: {
    home: "/clinic",
    chat: "/clinic/chat/:id/:userType",
  },
  qiosk: {
    checkin: "/qiosk",
  },
  provider: {
    home: "/provider",
  },
  patient: {
    home: "/patient",
    journey: "/patient/journey",
    chat: "/patient/chat/:id",
  },
};
